/* eslint-disable operator-linebreak */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';

import { CommonDatePicker, CommonInput, RegularButton } from 'pg-ui-library';
/* import { ReactComponent as EditSvg } from 'src/assets/edit-white.svg'; */

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import { monetaryUSDFormat } from 'src/utils/currencyFormat';
import { IEmployeeForm } from '../..';
import { Header, InputWrapper, TabWrapper } from './styles';

const EmploymentInformationTab: React.FC = () => {
  const { employee } = useTypedSelector(state => state.employees.data.selectedEmployee);

  const [editMode] = useState<boolean>(true);
  /*
  const handleEdit = (value: boolean) => {
    setEditMode(!value);
  };
  */
  const initialValuesInformation: Partial<IEmployeeForm> = {
    ...employee,
    hireDate: (employee?.hireDate && new Date(employee?.hireDate)) || '',
    rehireDate: (employee?.rehireDate && new Date(employee?.rehireDate)) || '',
    terminationDate: (employee?.terminationDate && new Date(employee?.terminationDate)) || '',
  };
  // eslint-disable-next-line no-unused-vars
  const onSubmit = async (values: Partial<IEmployeeForm>) => {};

  const { t } = useTranslation();

  const exportToExcel = (): void => {
    exportToXLSX([employee], employee?.name || 'employee-csv', 'employee');
  };

  return (
    <Formik initialValues={initialValuesInformation} onSubmit={onSubmit}>
      {({ handleChange, values }) => (
        <Form>
          <TabWrapper>
            <Header>
              <span>{t('employeePage.informationTab.employementInformation.title')}</span>
              <div>
                <RegularButton onClick={exportToExcel}>{t('global.form.export')}</RegularButton>
                {/*
                <RegularButton onClick={() => handleEdit(editMode)}>
                  <EditSvg />
                  {t('global.form.edit')}
                </RegularButton>
                */}
              </div>
            </Header>
            <InputWrapper>
              <CommonInput
                id="employeeId"
                name="employeeId"
                label={t('employeePage.informationTab.employementInformation.employeeId')}
                placeholder="Employee ID"
                value={values.employeeId}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="first_name"
                name="first_name"
                label={t('employeePage.informationTab.employementInformation.firstName')}
                placeholder="First Name"
                value={values.firstName}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="last_name"
                name="last_name"
                label={t('employeePage.informationTab.employementInformation.lastName')}
                placeholder="Last Name"
                value={values.lastName}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="email"
                name="email"
                label={t('employeePage.informationTab.employementInformation.email')}
                placeholder="Email"
                value={values.email}
                onChange={handleChange}
                disabled={editMode}
                style={{ minWidth: '300px' }}
              />
            </InputWrapper>
            <InputWrapper>
              <CommonDatePicker
                id="hireDate"
                name="hireDate"
                label={t('employeePage.informationTab.employementInformation.hireDate')}
                onChange={handleChange}
                disabled={editMode}
                placeholderText="MM/DD/YY"
              />
              <CommonDatePicker
                id="rehireDate"
                name="rehireDate"
                label={t('employeePage.informationTab.employementInformation.rehireDate')}
                onChange={handleChange}
                disabled={editMode}
                placeholderText="MM/DD/YY"
              />
              <CommonDatePicker
                id="terminationDate"
                name="terminationDate"
                label={t('employeePage.informationTab.employementInformation.terminationDate')}
                onChange={handleChange}
                disabled={editMode}
                placeholderText="MM/DD/YY"
              />
            </InputWrapper>
            <InputWrapper>
              <CommonInput
                id="workLocation"
                name="workLocation"
                label={t('employeePage.informationTab.employementInformation.workLocation')}
                placeholder="Work Location"
                value={values.workLocation}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="supervisor"
                name="supervisor"
                label={t('employeePage.informationTab.employementInformation.supervisor')}
                placeholder="Supervisor"
                value={values.supervisor}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="department"
                name="department"
                label={t('employeePage.informationTab.employementInformation.department')}
                placeholder="Department"
                value={values.department}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="position"
                name="position"
                label={t('employeePage.informationTab.employementInformation.position')}
                placeholder="Position"
                value={values.position}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="division"
                name="division"
                label={t('employeePage.informationTab.employementInformation.division')}
                placeholder="Division"
                value={values.division}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="employeeClass"
                name="employeeClass"
                label={t('employeePage.informationTab.employementInformation.company')}
                placeholder="Company"
                value={values.employeeClass}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="employmentStatus"
                name="employmentStatus"
                label={t('employeePage.informationTab.employementInformation.employmentStatus')}
                placeholder="Employement Status"
                value={values.employmentStatus}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="hrStatus"
                name="hrStatus"
                label={t('employeePage.informationTab.employementInformation.hrStatus')}
                placeholder="HR Status"
                value={values.hrStatus}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="employmentType"
                name="employmentType"
                label={t('employeePage.informationTab.employementInformation.employmentType')}
                placeholder="Employement Type"
                value={values.employmentType}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="workHours"
                name="workHours"
                label={t('employeePage.informationTab.employementInformation.workHours')}
                placeholder="Work Hours"
                value={values.workHours}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="positionType"
                name="positionType"
                label={t('employeePage.informationTab.employementInformation.positionType')}
                placeholder="Position Type"
                value={values.positionType}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="userDefined2"
                name="userDefined2"
                label={t('employeePage.informationTab.employementInformation.userDefined2')}
                placeholder="User Defined 2"
                value={values.userDefined2}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="organizationChart"
                name="organizationChart"
                label={t('employeePage.informationTab.employementInformation.organizationChart')}
                placeholder="Organization Chart"
                value={values.organizationChart}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="affCareFtStatus"
                name="affCareFtStatus"
                label={t('employeePage.informationTab.employementInformation.affordableCareActFullTimeStatus')}
                placeholder="Aff Care FT Status"
                value={values.affCareFtStatus}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="payRate"
                name="payRate"
                label={t('employeePage.personalTab.payRate')}
                placeholder="Pay Rate"
                value={monetaryUSDFormat(values.payRate || 0)}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="annualEquivalent"
                name="annualEquivalent"
                label={t('employeePage.personalTab.annualEquivalent')}
                placeholder="Annual Equivalent"
                value={monetaryUSDFormat(values.annualEquivalent || 0)}
                onChange={handleChange}
                disabled={editMode}
              />
            </InputWrapper>
          </TabWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default EmploymentInformationTab;
